import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@/api/base";
import { SNAPSHOT_COLLECTION_TAGS } from "@/modules/snapshots/snapshotCollection.constraints";
import { AUTHENTICATION_TAGS } from "@/api/authentication.constraints";
import { USERS_ADMIN_TAGS } from "@/api/users-admin.constraints";
import { TRANSACTIONS_TAGS } from "@/api/transactions.constraints";
import { OPEN_CHAT_TAGS } from "@/api/open-chat.constraints";
import { FILES_TAGS } from "@/api/files.constraints";
import { BUSINESS_REPORTS_TAGS } from "@/modules/snapshots/businessReports.constraints";
import { CHAT_TAGS } from "@/modules/chat/chat.constraints";
import { DOCUMENT_GROUP_TAGS } from "@/modules/documentGroup/documentGroup.constraints";
import { SHAREPOINT_TAGS } from "@/modules/sharepoint/sharepoint.constraints";
import { PROMPT_LIBRARY_TAGS } from "@/modules/promptLibrary/promptLibrary.constraints";
import { RECENT_QA_TAGS } from "@/modules/recent-qa/constraints";
import { CONTRACT_FAMILIES_TAGS } from "@/api/contract-families.constraints";
import { SNAPSHOT_VIEW_TAGS } from "@/modules/snapshots/snapshotViews.constraints";
import { SUPPLIER_TAGS } from "@/api/suppliers.constraints";
import { RENEWAL_TAGS } from "@/api/renewals.constraints";
import { SPEND_TAGS } from "@/api/spend.constraints";
import { DOCUMENT_AUTHORING_TAGS } from "@/modules/documentAuthoring/documentAuthoring.constraints";

export const baseApi = createApi({
  reducerPath: "api",
  refetchOnFocus: false,
  baseQuery: axiosBaseQuery({ baseUrl: "" }),
  tagTypes: [
    ...Object.values(SNAPSHOT_COLLECTION_TAGS),
    ...Object.values(AUTHENTICATION_TAGS),
    ...Object.values(USERS_ADMIN_TAGS),
    ...Object.values(TRANSACTIONS_TAGS),
    ...Object.values(OPEN_CHAT_TAGS),
    ...Object.values(FILES_TAGS),
    ...Object.values(BUSINESS_REPORTS_TAGS),
    ...Object.values(CHAT_TAGS),
    ...Object.values(DOCUMENT_GROUP_TAGS),
    ...Object.values(SHAREPOINT_TAGS),
    ...Object.values(PROMPT_LIBRARY_TAGS),
    ...Object.values(RECENT_QA_TAGS),
    ...Object.values(CONTRACT_FAMILIES_TAGS),
    ...Object.values(SNAPSHOT_VIEW_TAGS),
    ...Object.values(SUPPLIER_TAGS),
    ...Object.values(SPEND_TAGS),
    ...Object.values(RENEWAL_TAGS),
    ...Object.values(DOCUMENT_AUTHORING_TAGS),
  ],
  endpoints: () => ({}),
});
